<template>
  <w-sliding-popup type="setting" ref="slidingPopup" :title="popupTitle" width="1000px" @close="close">
    <div slot="content">
      <!-- 인터페이스 그룹 정보 설정 view -->
      <w-basic-info-setting-view v-show="currentView === 'basicInfoView'" :view-params="basicInfoParams" @change-view="changeView" ref="basicInfoView"></w-basic-info-setting-view>
      <!-- 인터페이스 추가 view -->
      <w-add-interface-setting-view v-show="currentView === 'addInterfaceView'" :active="currentView === 'addInterfaceView'" :view-params="addInterfaceParams" @change-view="changeView" ref="addInterfaceView"></w-add-interface-setting-view>
    </div>
    <div slot="footer">
      <!-- 인터페이스 그룹 정보 설정 view -->
      <div v-show="currentView === 'basicInfoView'">
        <el-button size="large" type="solid" @click="onSaveButtonClick">저장</el-button>
        <el-button size="large" @click="close">취소</el-button>
      </div>
      <!-- 인터페이스 추가 view -->
      <div v-show="currentView === 'addInterfaceView'">
        <el-button size="large" type="solid" @click="onAddButtonClick">추가</el-button>
        <el-button size="large" @click="changeView('basicInfoView')">취소</el-button>
      </div>
    </div>
  </w-sliding-popup>
</template>

<script>
import msgUtil from '@/utils/message';
import isEmpty from 'lodash/isEmpty';
import trafficAPI from '@/api/settings/netdevice/traffic-settings';
import WBasicInfoSettingView from '../components/BasicInfoSettingView';
import WAddInterfaceSettingView from '../components/AddInterfaceSettingView';

export default {
  name: 'WInterfaceGroupSettingSlidingPopup',
  components: {
    WBasicInfoSettingView,
    WAddInterfaceSettingView,
  },
  props: {
    popupParams: Object,
  },
  data() {
    return {
      popupVisible: false,
      popupTitle: '',
      currentView: 'basicInfoView',
      basicInfoParams: { orderbyIndex: 0, selectedRecord: {}, interfaceList: [] },
    };
  },
  computed: {
    addInterfaceParams() {
      return {
        currentView: this.currentView,
        interfaceList: [],
      };
    },
  },
  methods: {
    open() {
      this.popupVisible = true;
      this.$refs.slidingPopup.visible = true;

      if (this.popupParams.popupType === 'ADD') {
        const interfaceGroupList = this.popupParams.interfaceGroupList;
        this.basicInfoParams.orderbyIndex = interfaceGroupList.length > 0 ? interfaceGroupList[interfaceGroupList.length - 1].orderbyIndex + 1 : 1;
        this.popupTitle = '인터페이스 그룹 추가';
      } else if (this.popupParams.popupType === 'UPDATE') {
        const selectedRecord = this.popupParams.selectedRecord;
        trafficAPI.getInterfaceGroupInterfaceList({ interfaceGroupId: selectedRecord.interfaceGroupId }).then((response) => {
          if (response.data.success) {
            const interfaceList = response.data.data;
            this.basicInfoParams.selectedRecord = { interfaceList, ...selectedRecord };
            this.basicInfoParams.interfaceList = interfaceList;
            this.popupTitle = `[ ${selectedRecord.interfaceGroupName} ] 인터페이스 그룹 정보`;
          }
        });
      }
    },
    close() {
      this.popupVisible = false;
      this.$refs.slidingPopup.visible = false;

      this.changeView('basicInfoView');
      this.$refs.basicInfoView.initData();
      this.basicInfoParams = { orderbyIndex: 0, selectedRecord: {}, interfaceList: [] };
    },
    /**
     * 기본정보, 인터페이스 추가 화면 변경
     * @author jeee12
     * @param  {[type]} viewType  화면 타입
     * @param  {[type]} interfaceList  전달할 인터페이스 목록
     */
    changeView(viewType, interfaceList) {
      this.currentView = viewType;
      if (interfaceList && interfaceList.length > 0) {
        this.addInterfaceParams.interfaceList = interfaceList;
      }
      if (viewType === 'basicInfoView') {
        this.$refs.addInterfaceView.initData();
      }
    },
    /**
     * 기본정보 > 저장 버튼 click
     * @author jeee12
     * @return {[type]} [description]
     */
    onSaveButtonClick() {
      const settingInfo = this.$refs.basicInfoView.getBasicInfo();
      settingInfo.validate().then((response) => {
        if (response) {
          if (settingInfo.basicInfo.interfaceList && settingInfo.basicInfo.interfaceList.length === 0) {
            this.$message(msgUtil.getCustomMsgData('인터페이스를 추가해주십시오.'));
          } else {
            this.$confirm('저장하시겠습니까?', '확인', {
              confirmButtonText: '확인',
              cancelButtonText: '취소',
            }).then(() => {
              if (!isEmpty(settingInfo.basicInfo)) {
                // 추가 또는 수정된 항목 존재시
                const saveType = this.popupParams.popupType.toLowerCase();
                // 추가 또는 수정 (addInterfaceGroup, updateInterfaceGroup)
                trafficAPI[`${saveType}InterfaceGroup`](settingInfo.basicInfo).then((res) => {
                  if (res.data.success) {
                    this.$alert('인터페이스 그룹을 저장하였습니다.', '정보', {
                      callback: () => {
                        this.$emit('reload');
                      },
                    });
                  }
                });
              }
              this.close();
            }).catch(() => {});
          }
        }
      }).catch(() => {});
    },
    /**
     * 인터페이스 추가 > 추가 버튼 click
     * @author jeee12
     * @return {[type]} [description]
     */
    onAddButtonClick() {
      const addInterfaces = this.$refs.addInterfaceView.getAddInterfaceInfo().addedInterfaces;
      this.basicInfoParams.interfaceList = addInterfaces;
      this.changeView('basicInfoView');
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/TrafficSettings/InterfaceGroupSettings/popup/InterfaceGroupSettingSlidingPopup.vue